<template>
    <div>
        <el-form ref="formRef" :rules='formRules' :model="form" label-width="90px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select :disabled="model!='add'"  v-model="form.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="区域名称" prop="areaId" >            
                                <div style="display:flex">
                                        <el-input v-model="form.areaName" disabled></el-input>
                                       <div v-if="model!='view'">
                                         <el-button size="small" type="primary" @click="openChoiceAreaDialog">添加</el-button>
                                          <ChoiceArea  @close="choiceClose" v-if="choiceAreaFlag" :projectId="form.projectId" @getArea='getArea'></ChoiceArea> 
                                       </div>
                                </div>
                          </el-form-item>
                      </el-col>

                      
                    
                      <el-col :span="8">
                          <el-form-item label="区域编号" prop="code" >
                              <el-input disabled v-model="form.code"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="16">
                          <el-form-item label="区域全称" prop="arareaType">
                             <el-input v-model="form.fullName" disabled></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="所属部门" prop="deptName" >
                              <el-input disabled v-model="form.deptName"></el-input>
                          </el-form-item>
                      </el-col>
                       <el-col :span="8">
                        <el-form-item label="巡查类型" prop="inspectType">
                          <el-select :disabled="model=='view'" v-model="form.inspectType" placeholder="巡查类型" style="width:100%" @change="inspectTypeChange">
                            <el-option
                              v-for="item in inspectTypeList"
                              :key="item.dictKey"
                              :label="item.dictValue"
                              :value="item.dictKey"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="标准名称" prop="standardId" >
                               <el-select :disabled="model=='view'"  v-model="form.standardId" placeholder="请选择" style="width:100%" @change="standardIdChange">
                                  <el-option
                                      v-for="item in inspectstandardList"
                                      :key="item.standardId"
                                      :label="item.standardName"
                                      :value="item.standardId">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8" style="height:54px" >
                          <el-form-item  label="巡检时间" prop="realInspectTime" style="width:100%" >
                            
                             <el-date-picker
                            :disabled="model=='view'"
                             style="width:100%" 
                            v-model="form.realInspectTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="巡检人员" prop="realInspectManId" >
                                 <choicePeople :disabled="model=='view'" ref="transformPeopleRef"  :option="choicePeopleOption" @getPeople="getPeople" />
                              
                          </el-form-item>
                      </el-col>
                       
                      <el-col :span="24">
                          <el-form-item label="巡检标准" prop="InspectionStatus"  >
                               <el-table
                                :data="standardList"
                                border
                                style="width: 100%">
                                <el-table-column
                                  type="index"
                                  label="#"
                                  width="50">
                                </el-table-column>
                                <el-table-column
                                  prop="standardDetailContent"
                                  label="标准内容"
                                  >
                                </el-table-column>
                                <el-table-column
                                  align="center"
                                  label="操作"
                                  width="300">
                                  <template slot-scope="scope">
                                    <div style="    text-align: center;">
                                      
                                      <el-button size="mini" type="primary" 
                                      :disabled="item.dictKey==scope.row.selectedOperation"
                                       v-for="(item, index) in currentDataOption" 
                                       :key="index"
                                       @click="standardEvaluate(scope.row,item.dictKey,item.dictValue)"
                                       
                                        >{{item.dictValue}}</el-button>
                                    </div>
                                  </template>
                                </el-table-column>
                              </el-table>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="巡检结果" prop="errorFlag" >
                              <el-select  :disabled="model=='view'" v-model="form.errorFlag" placeholder="请选择"  >
                                  <el-option
                                      v-for="item in inspectionResultList"
                                      :key="item.errorFlag"
                                      :label="item.name"
                                      :value="item.errorFlag">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="备注" prop="description" >
                              <el-input :disabled="model=='view'"  type="textarea" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="上传附件" prop="code" >
                              <VUpload :disabled="model=='view'" :fileList="form.attachList" ></VUpload>
                          </el-form-item>
                      </el-col>
                      
                </el-row>
          </el-form>
            
            <div class="btnArea" style="text-align:right" v-if="model!=='view'">
                <el-button type="primary" @click="submitRecord"   size="small"    icon="el-icon-circle-plus-outline" style="margin-right: 20px"
                  >{{model=='add'?'保存':'修改'}}</el-button
                >
                <el-button @click="closeRecord" icon="el-icon-circle-close"  size="small" >取消</el-button>
            </div>
            <!-- 选择区域对话框 -->
            <el-dialog
            title="选择区域"
            v-if="choicearareaDialogFlag"
            :visible.sync="choicearareaDialogFlag"
            append-to-body="true"
            width="80%"
            >
            <choiceararea v-if="choicearareaDialogFlag" @cancleOperate="choicearareaCancleOperate" :projectId="this.form.projectId" @choiceData="getararea"></choiceararea>
            </el-dialog>
           
    </div>
</template>

<script>


import { getProjectList } from '@/api/crmedical/project/project';
import VUpload from '@/views/components/v-upload';
import choiceContract from '@/components/choiceContract/choiceContract';
import ATime from '@/components/aTime/index';


import ChoiceArea from "./choiceArea.vue"
import {getDictionary,getBisDictData,getStandardName,getStandardById,saveGeneral,taskGeneralDetail,taskGeneralSubmit} from '@/api/crmedical/comprehensiveInspect/index.js'
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';
export default {
  components: { VUpload, choiceContract, ATime ,choicePeople,ChoiceArea},
  props: ['row','model'],
  data() {
    return {
      choiceAreaFlag:false,
      inspectTypeList:[],
      form:{},
      standardList:[],
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },

      projectList:[],
      isEdit:false,
      realInspectManList:[],
      inspectionResultList: [
        {
          errorFlag: '1',
          name: '异常',
        },
        {
          errorFlag: '0',
          name: '正常',
        },
      ],
      inspectstandardList:[],
      currentDataOption: [],
      handleIdList: [], //处理人
      OperateList: [],
      isUpdate: false,
      //判断是否为编辑
      operatConsumableIndex: undefined,
      choiceConsumableFlag: false, //选择耗材对话框
      choiceContractDialogFlag: false, //选择区域对话框
      choicearareaDialogFlag: false, //选择区域对话框
      consumable: {
        consumableId: '',
        consumableName: '',
        specification: '',
        vender: '',
        consumeNum: '',
        consumePrice: '',
      },
      consumablesList: [
        {
          consumableId: '',
          consumableName: '',
          specification: '',
          vender: '',
          consumeNum: '',
          consumePrice: '',
        },
      ],
      dialogVisible: false,
      dialogConstract: {},
      formRules: {
        areaId: [{ required: true, message: '请选择区域', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        inspectType: [{ required: true, message: '请选择巡查类型', trigger: 'change' }],
         standardId: [{ required: true, message: '请选择标准名称', trigger: 'change' }],
        realInspectTime: [{ required: true, message: '请选择巡检时间', trigger: 'blur' }],
        realInspectManId: [{ required: true, message: '请选择巡检人', trigger: 'blur' }],
        errorFlag: [{ required: true, message: '请选择巡检结果', trigger: 'blur' }],
      },
    };
  },
  created() {
    console.log("综合巡查")
    this.form = Object.assign({},this.row)
    this.choicePeopleOption.projectId = this.row.projectId
    this.noAddInit();
    this.initData();
  },
  watch:{

     
    'form.inspectType'(){
      if(this.form.inspectType!=''&&this.form.inspectType!=undefined){
        this.getStandardBysubTypeId(this.form.inspectType,this.form.projectId).then(res=>{
          this.inspectstandardList = res
        })
      }
    },
    
  },
  methods: {
    choiceClose(){
      this.choiceAreaFlag = false
    },
    openChoiceAreaDialog(){
      this.choiceAreaFlag = true
    },
    inspectTypeChange(){
      // this.form.standardId = ''
      this.$set(this.form,'standardId','')
      this.standardList = []
    },
    //非新增初始化数据
    noAddInit(){
      if(this.model != 'add'){
        this.standardList = this.form.generalInspectTaskListStandards
          this.form.inspectType+=''
          this.getStandardBysubTypeId(this.form.inspectType,this.form.projectId).then(res=>{
            this.inspectstandardList = res  
        })
        //选人组件赋值
        if(this.form.realInspectManId!=''&&this.form.realInspectManId!=undefined&&this.form.realInspectManId!=null&&this.form.realInspectManId!=-1){
           this.choicePeopleOption.selectList = [{id:this.form.realInspectManId,realName:this.form.realInspectManName}]
        }
        if(this.form.errorFlag==-1){
          this.form.errorFlag=''
        }
      }
    },
    standardIdChange(){
      if(this.form.standardId){
        this.getStandardDetailById(this.form.standardId)
      }
    },
    getPeople(data){
      //
      console.log('yue',data)
      this.form.realInspectManName = data.realName
      this.$set(this.form,'realInspectManId',data.id)
      if(data.realName){
         this.$refs['formRef'].clearValidate('realInspectManId')
      }
      

    },
    //根据标准id获取标准
    getStandardDetailById(id){
      console.log('ddd')
      getStandardById({
        standardId:id
      }).then(res=>{
        this.standardList = res.data
        this.standardList.forEach((item) => {
          item.standardDetailContent = item.content;
        });
        let arry = res.data[0].optionalOperations.split(',');
        console.log('arry', arry);
        console.log('this.standardList', this.standardList);
          console.log("渲染的操作项前",this.currentDataOption)
           this.currentDataOption=[]
        this.OperateList.forEach((item) => {
          arry.forEach((ele) => {
            if (item.dictKey == ele) {
              let obj = {
                dictKey: item.dictKey,
                dictValue: item.dictValue,
              };
              this.currentDataOption.push(obj);
            }
          });
        });
        console.log("渲染的操作项",this.currentDataOption)
      })
    },
    //根据工单子类型获取标准
              async  getStandardBysubTypeId(inspectType,projectId){
                      console.log("89898")
                        let data =[]
                     await   getStandardName({
                                projectId,
                                inspectType
                        }).then(res=>{
                                  data = res.data 
                        })
                        return data
                },
    //获取巡查类型
      async getInspectTypeList(id){
       
       await getBisDictData({
             projectId:id,
             code:'project_general_inspect_type'
        }).then(res=>{
            this.inspectTypeList = res.data
        })
       
    },
    getArea(areaObj){
        // console.log("quyu:",data)
        // let areaObj =data[0]
        this.form.code = areaObj.code
        this.form.areaName = areaObj.name
        this.form.deptName = areaObj.$deptId
        this.form.fullName =areaObj.fullName
        this.form.areaId = areaObj.id
        console.log('dxzc',this.form)
    },
    getProjectList(){
        getProjectList().then(res=>{
          this.projectList = res.data
        })
    },
    choicearareaCancleOperate() {
      this.choicearareaDialogFlag = false;
    },
    projectIdChange(val) {
      getBisDictData({
        code: 'project_general_inspect_operation',
        projectId: val,
      }).then((res)=>{
        this.OperateList = res.data;
      })
      this.handleIdList = [];
      this.tool.clearObject(this.form)
      this.form.projectId = val
      this.currentDataOption = [];
      this.standardList = [];
      this.choicePeopleOption.selectList =[]
      this.$refs['transformPeopleRef'].updateData()
      this.choicePeopleOption.projectId = this.form.projectId
      this.realInspectManList = []
       this.getInspectTypeList(this.form.projectId)
      this.$forceUpdate()
    },
    standardEvaluate(row, optionValue, optionName) {
      if (this.model=='add'||this.model=='update') {
        this.$set(row, 'selectedOperation', optionValue);
        this.$set(row, 'selectedOperationValue', optionName);
        this.$message.success('操作成功');
        console.log('操作后', this.standardList);
      } else {
        return;
      }
    },
    maintenanceTime(date) {
      //维修完成时间
      this.form.serviceHour = Number(date.hour) * 60 + Number(date.minutes);
    },
    initData() {
      getBisDictData({
        code: 'project_general_inspect_operation',
        projectId: this.row.projectId,
      }).then((res) => {
        this.OperateList = res.data;
        console.log('操作选择', this.OperateList);
        console.log('操作optionalOperations', this.form.optionalOperations);
        if (this.row.optionalOperations) {
          let arry = this.row.optionalOperations.split(',');
          this.currentDataOption =[]
          this.OperateList.forEach((item) => {
            arry.forEach((ele) => {
              if (item.dictKey == ele) {
                let obj = {
                  dictKey: item.dictKey,
                  dictValue: item.dictValue,
                };
                this.currentDataOption.push(obj);
              }
            });
          });
        }
      });
     this.getProjectList()
     this.getInspectTypeList(this.form.projectId)
      console.log('所有form数据', this.form);
    },
    submitRecord() {
      console.log(this.form);
      console.log(this.realInspectManList)
      this.$refs['formRef'].validate(async(valid) => {
        if (valid) {
          if(this.standardList.length>0){
            for (let i = 0; i < this.standardList.length; i++) {
            if (this.standardList[i].selectedOperation) {
              continue;
            } else {
              // this.form.InspectionStatus = false;
              this.$message.error('有未操作巡检项，请核对');
              return;
            }
          } //判断是否所有的标准都评价了
          }
          let arrVaule = [];
            let arrName = [];
            console.log('this.currentDataOption', this.currentDataOption);
            this.currentDataOption.forEach((item) => {
              arrVaule.push(item.dictKey);
              arrName.push(item.dictValue);
            });
           
            let obj = {
              generalInspectTaskListStandards: this.standardList,
              optionalOperations: arrVaule.join(','),
              optionalOperationValues: arrName.join(','),
            };
            if(this.standardList.length>0){//后端的要求
              obj.standardId = this.standardList[0].standardId
              obj.standardName = this.standardList[0].standardName
            }
            console.log(this.form);
            if (this.model=='update') {
            await taskGeneralSubmit(Object.assign({}, this.form, obj)).then(() => {
                this.$message.success('编辑巡检记录成功'); 
              });
            
               
                this.$emit('submitOver');
             
            } else {
            await  saveGeneral(Object.assign({},  this.form, obj)).then(() => {
                this.$message.success('新增巡检记录成功');
                
                 
              });
              
                this.$emit('submitOver');
              
            }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // getararea(val) {
    //   console.log(val);
    //   console.log('查询标准');
    //   //根据区域id查找标准
    //   getStandardByarareaId({ id: val.id }).then(({ data }) => {
    //     this.standardList = data;
    //     this.standardList.forEach((item) => {
    //       item.standardDetailContent = item.content;
    //     });
    //     let arry = data[0].optionalOperations.split(',');
    //     console.log('arry', arry);
    //     console.log('this.standardList', this.standardList);
    //     this.OperateList.forEach((item) => {
    //       arry.forEach((ele) => {
    //         if (item.dictKey == ele) {
    //           let obj = {
    //             dictKey: item.dictKey,
    //             dictValue: item.dictValue,
    //           };
    //           this.currentDataOption.push(obj);
    //         }
    //       });
    //     });
       
    //   });
      
    //   this.$set(this.form, 'arareaId', val.id);
    //   this.$set(this.form, 'arareaName', val.name);

    //   this.form.areaName = val.areaName;
    //   this.form.arareaType = val.typeName;
    //   this.form.code = val.code;
    //   this.form.deptName = val.deptName;
    //   this.choicearareaDialogFlag = false;
    // },

    choiceararea() {
      this.choicearareaDialogFlag = true;
    },

    closeRecord() {
      this.$emit('cancelOperate');
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    getGroupListByModuleType(projectId) {
      getGroupListByModuleType({ projectId: projectId }).then((res) => {
        res.data.forEach((item) => {
          item.label = item.realNameAndPhone;
          item.value = item.userId;
        });
        this.handleIdList = res.data;
      });
    },
    
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: center;
}
::v-deep .el-col-8{
  height: 54px;
}
</style>
